import React from "react";
import { useParams, Link } from "react-router-dom";
import services from "../data/serviceData";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import  AboutBreadcrumb  from "../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb"
import "./ServiceDetailsPage.css";

const ServiceDetailsPage = () => {
  const { slug } = useParams();

  const service = services.find((item) => item.slug === slug);

  if (!service) {
    return (
      <h2 style={{ padding: "100px", textAlign: "center" }}>
        Service Not Found
      </h2>
    );
  }

  return (
    <>
      <Header />
<AboutBreadcrumb label={service.title} />

      <section className="service-details">
        <div className="service-details-container">

          {/* LEFT CONTENT */}
          <div className="service-main">
            <img src={service.image} alt={service.title} />
            <h1>{service.title}</h1>
<div
  className="service-content"
  dangerouslySetInnerHTML={{ __html: service.content }}
></div>
          </div>

          {/* RIGHT SIDEBAR */}
          <aside className="service-sidebar">

            {/* SERVICES LIST */}
            <div className="sidebar-box">
              <h4>Our Services</h4>
              <ul className="service-list">
                {services.map((item) => (
                  <li
                    key={item.id}
                    className={item.slug === slug ? "active" : ""}
                  >
                    <Link to={`/services/${item.slug}`}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* CTA BUTTONS */}
            <div className="sidebar-box cta-box">
              <Link to="/contact" className="btn-quote">
                Get a Quote
              </Link>

              <a
                href={`${process.env.PUBLIC_URL}/assets/brochure/IntelBuild-Brochure.pdf`}
                download
                className="btn-brochure"
              >
                Download Brochure
              </a>
            </div>

          </aside>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default ServiceDetailsPage;
